<template>
  <div class="py-4 container-fluid">
    <h4 class="text-white">TURNOS</h4>
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <div class="nav-wrapper position-relative end-0">
              <ul class="p-1 bg-transparent nav nav-pills nav-fill">
                <li class="nav-item">
                  <a
                    class="mb-3 btn btn-sm w-100 btn-info"
                    style="cursor: pointer"
                    >GESTIONAR TURNO</a
                  >
                </li>
              </ul>
            </div>
            <div class="card-body">
              <div class="tab-content">
                <!-- -------------------------------------------------------------------------- -->
                <div class="row justify-content-center">
                  <div
                    v-show="!vergestionarturno"
                    class="col-lg-6 col-md-6 col-12"
                    style="cursor: pointer"
                  >
                    <a
                      @click="llamar_turno_nuevo('I', 'LLAMAR')"
                      class="card btn-info border-0"
                    >
                      <div class="card-body">
                        <div class="row">
                          <div class="col text-center">
                            <span class="h3 font-weight-bold mb-0 text-white"
                              >LLAMAR TURNO</span
                            >
                            <br />
                            <i class="ni ni-send coloriconos ni-5x"></i>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                <div v-show="vergestionarturno">
                  <div class="text-center">
                    <h1 class="tiempo-texto">{{ tiempoFormateado }}</h1>
                    <br>
                    <span
                      class="badge badge-pill badge-lg btn-info"
                      style="font-size: larger"
                      >TURNO:</span
                    >
                    <h2>{{ datosdelturno.documento }}</h2>
                  </div>
                  <!-- <div class="row">
                    <div class="col-md-12">
                      <h6><strong>Servicio Presentado</strong></h6>
                      <div class="form-group">
                        <select class="form-select" v-model="subservicioenviar">
                          <option value="">Seleccionar Subservicio</option>
                          <option
                            v-for="item in listadosubservicios"
                            :value="item.id"
                            :key="item.id"
                          >
                            {{ item.nombre_sub }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div> -->
                </div>
                <div
                  v-show="vergestionarturno"
                  class="row justify-content-center mt-2"
                >
                  <div class="col-lg-4 col-md-4 col-12" style="cursor: pointer">
                    <a
                      @click="llamar_turno_nuevo('F', 'FINALIZAR')"
                      class="card bg-gradient-danger border-0"
                    >
                      <div class="card-body">
                        <div class="row">
                          <div class="col text-center">
                            <span class="h3 font-weight-bold mb-0 text-white"
                              >ATENDIDO</span
                            >
                            <br />
                            <i class="ni ni-button-pause coloriconos ni-5x"></i>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12" style="cursor: pointer">
                    <a
                      @click="llamar_de_nuevo()"
                      class="card btn-info border-0"
                    >
                      <div class="card-body">
                        <div class="row">
                          <div class="col text-center">
                            <span class="h3 font-weight-bold mb-0 text-white"
                              >RECORDAR</span
                            >
                            <br />
                            <i
                              class="ni ni-notification-70 coloriconos ni-5x"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12" style="cursor: pointer">
                    <a
                      @click="nopresentacliente()"
                      class="card btn-info border-0"
                    >
                      <div class="card-body">
                        <div class="row">
                          <div class="col text-center">
                            <span class="h3 font-weight-bold mb-0 text-white"
                              >NO PRESENTE</span
                            >
                            <br />
                            <i class="ni ni-button-power coloriconos ni-5x"></i>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="text-center mt-2">
<h6>ATENCION TRAMITES DE:{{nombreservicio}}</h6>
                </div>
                <!-- ------------------------------------------------------------------------------- -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card card-profile">
          <div class="row justify-content-center">
            <div class="table-responsive">
              <div
                style="width: auto; height: 380px; overflow: auto"
                class="p-4"
              >
                <table class="table align-items-center">
                  <thead class="thead-light">
                    <tr>
                      <th
                        class="text-center d-flex align-items-center justify-content-center"
                      >
                        <h4>Siguiente para llamar</h4>
                      </th>
                      <!-- <th>Turno</th> -->
                    </tr>
                  </thead>
                  <tbody
                    v-for="(tur, index) in datostodoslosturnos"
                    :key="index"
                  >
                    <tr>
                      <td
                        class="text-center d-flex align-items-center justify-content-center align-items-baseline"
                      >
                        <a v-if="vergestionarturno"
                          type="button"
                          class="btn-sm bg-gradient-danger btn-icon-only"
                          style="
                            margin-right: 8px;
                            width: 37px;
                            padding: 0.5rem 0.5rem;
                          "
                        >
                          <i class="ni ni-send text-white"></i>
                        </a>
                        <a v-if="!vergestionarturno"
                          type="button"
                           @click="llamarseleccionturno(tur.id,tur.cliente)"
                          class="btn-sm bg-gradient-info btn-icon-only"
                          style="
                            margin-right: 8px;
                            width: 37px;
                            padding: 0.5rem 0.5rem;
                          "
                        >
                          <i class="ni ni-send text-white"></i>
                        </a>

                        <span class="text-lg font-weight-bolder">
                          {{ tur.cliente }}</span
                        >
                      </td>
                      
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col">
                <div class="d-flex justify-content-center">
                  <div class="d-grid text-center">
                    <span class="text-lg font-weight-bolder">{{
                      datoscantidad.ACTIVOS
                    }}</span>
                    <span class="text-sm opacity-8">En Espera</span>
                  </div>
                  <div class="d-grid text-center mx-4">
                    <span class="text-lg font-weight-bolder">{{
                      datoscantidad.FINALIZADO
                    }}</span>
                    <span class="text-sm opacity-8">Atendidos</span>
                  </div>
                  <div class="d-grid text-center">
                    <span class="text-lg font-weight-bolder">{{
                      datoscantidad.TURNOS
                    }}</span>
                    <span class="text-sm opacity-8">Totales</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mt-4">
              <span class="text-sm opacity-8">{{ modulo_nombre }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- -------------------modal----------------------------- -->
    <div
      id="modalllamarturno"
      ref="modalImport"
      class="modal fade"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog mt-lg-10">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="ModalLabel" class="modal-title">
              <div class="text-center">
                <h4>REALIZAR LLAMADO DE TURNO SERVICIO</h4>
              </div>
            </h5>
          </div>
          <div class="modal-body"></div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              type="button"
              class="btn bg-gradient-danger btn-sm"
              @click="cerrarModal()"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- -------------------modal----------------------------- -->
  </div>
</template>

<script>
import axios from "axios";
import { Modal } from "bootstrap";
export default {
  name: "profile",
  data() {
    return {
      activo: false,
       tiempo: 0,
      inicio: null,
      intervalId: null,
      cantidadquehay: 0,
      modalInstance: null,
      showImportModal: false,
      vergestionarturno: false,
      subservicioenviar: "",
      datostodoslosturnos: [],
      listadosubservicios: [],
      datoscantidad: "",
      datosdelturno: "",
      estadoturno: "",
      numerocedula: "",
      id_servicio: "",
      servicio_nombre: "",
      modulo_nombre: "",
      servicio: "",
      nombreservicio: "",
    };
  },
  computed: {
     tiempoFormateado() {
      return this.formatearTiempo(this.tiempo)
    },
    
  },
   beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  mounted() {
     const guardado = localStorage.getItem('inicio')
  if (guardado) {
    this.inicio = parseInt(guardado)
    this.iniciar()
  }
    this.cantidad_de_turnos();
    this.modulo_nombre = sessionStorage.getItem("modulo_nombre");
    this.servicio = localStorage.getItem("servicio");
    this.nombreservicio = localStorage.getItem("nombreservicio");
    this.subservicios(this.servicio);
     setInterval(() => {
            this.seregistronuevoturno(this.servicio);
            this.datosdelosturnos();
          }, 5000);
  },
  methods: {
iniciar() {
  if (!this.activo) {
    this.activo = true
    if (!this.inicio) {
      this.inicio = Date.now()
      localStorage.setItem('inicio', this.inicio)
    }
    this.intervalId = setInterval(() => {
      this.tiempo = Math.floor((Date.now() - this.inicio) / 1000)
    }, 1000)
  }
},
detener() {
  if (this.activo) {
    this.activo = false
    clearInterval(this.intervalId)
    this.intervalId = null
    this.tiempo = 0
    this.inicio = null
    localStorage.removeItem('inicio')
  }
},
  formatearTiempo(segundosTotales) {
    const horas = Math.floor(segundosTotales / 3600)
    const minutos = Math.floor((segundosTotales % 3600) / 60)
    const segundos = segundosTotales % 60

    const horasStr = horas.toString().padStart(2, '0')
    const minutosStr = minutos.toString().padStart(2, '0')
    const segundosStr = segundos.toString().padStart(2, '0')

    return `${horasStr}:${minutosStr}:${segundosStr}`
  },
    seregistronuevoturno(servicioutilizar) {
      var datosenviar = {
        idservicio: servicioutilizar,
      };
      axios
        .post("versihaynuevosturnos", datosenviar)
        .then((respuesta) => {
            const nuevaCantidad = respuesta.data[0].cantidad;
            if (nuevaCantidad > this.cantidadquehay) {
                this.generarSonidoTimbre();
                this.$swal.fire({
                    title: '¡Nuevo Turno Registrado!',
                    text: `Se han registrado ${nuevaCantidad - this.cantidadquehay} nuevo(s) turno(s)`,
                    icon: 'info',
                    timer: 5000,
                    timerProgressBar: true,
                    showConfirmButton: false
                });
            }
            
            this.cantidadquehay = nuevaCantidad;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.$swal.fire(
              "Ups!!",
              "Token Invalido Cierre Session e Ingrese de Nuevo",
              "error"
            );
          }
        });
    },
    generarSonidoTimbre() {
   const audio = new Audio('/alarmanuevoturno.mp3');
    audio.play().catch(e => console.log('Error al reproducir sonido:', e));
},
    subservicios(servicioutilizar) {
      var datosenviar = {
        idservicio: servicioutilizar,
      };
      axios
        .post("llamar_subservicios", datosenviar)
        .then((respuesta) => {
          this.listadosubservicios = respuesta.data;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.$swal.fire(
              "Ups!!",
              "Token Invalido Cierre Session e Ingrese de Nuevo",
              "error"
            );
          }
        });
    },
    cantidad_de_turnos() {
      axios
        .post("ver_cantidad_turnos")
        .then((respuesta) => {
          this.datoscantidad = respuesta.data[0];
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.$swal.fire(
              "Ups!!",
              "Token Invalido Cierre Session e Ingrese de Nuevo",
              "error"
            );
          }
        });
    },
    datosdelosturnos() {
      axios
        .post("detalleturnos")
        .then((respuesta) => {
          this.datostodoslosturnos = respuesta.data;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.$swal.fire(
              "Ups!!",
              "Token Invalido Cierre Session e Ingrese de Nuevo",
              "error"
            );
          }
        });
    },
    abrirModal() {
      const modalElement = this.$refs.modalImport;
      this.modalInstance = new Modal(modalElement);
      this.modalInstance.show();
    },
    cerrarModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },

    llamar_turno_nuevo(accion, mensaje) {
     
      this.$swal
        .fire({
          title: mensaje,
          text: "Esta seguro de " + mensaje + " Turno!",
          icon: "info",
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: mensaje,
          cancelButtonColor: "#d33",
        })
        .then((result) => {
          if (result.isConfirmed) {
             if (accion == "F") {
        this.detener();
      } else {
        this.iniciar();
      }
            this.$swal.fire({
              html: "Cargando por favor espere.",
              allowOutsideClick: false,
              timerProgressBar: true,
              didOpen: () => {
                this.$swal.showLoading();
              },
            });
            const tokenpeticion = {
              v_accion: accion,
              subservicioenviar: this.subservicioenviar,
            };
            axios
              .post("llamarturno", tokenpeticion)
              .then((respuesta) => {
                this.estadoturno = "";
                this.$swal.close();
                this.datosdelosturnos();
                this.cantidad_de_turnos();
                if (respuesta.data[0].codigo == 1) {
                  this.$swal.fire(
                    "Exitoso",
                    "Turno Finalizado Correctamente",
                    "success"
                  );
                  this.vergestionarturno = false;
                } else if (respuesta.data[0].codigo == 0) {
                  this.datosdelturno = respuesta.data[0];
                  this.estadoturno = respuesta.data[0].estado_turno;
                  this.cantidad_de_turnos();
                  this.vergestionarturno = true;
                } else if (respuesta.data[0].codigo == 2) {
                  this.$swal.fire(
                    "Ups!!",
                    "No hay Turnos Pendientes para este servicio",
                    "info"
                  );
                } else {
                  this.$swal.fire("Ups!!", "No hay Turnos Pendientes", "info");
                }
              })
              .catch((error) => {
                if (error.response.status == 400) {
                  this.$swal.fire(
                    "Ups!!",
                    "Token Invalido Cierre Session e Ingrese de Nuevo",
                    "error"
                  );
                }
              });
          }
        });
    },
    llamar_de_nuevo() {
      const tokenpeticion = {
        numerodeturno: this.datosdelturno.id,
      };
      axios
        .post("llamardenuevo", tokenpeticion)
        .then((respuesta) => {
          this.$swal.fire(
            "Exitoso",
            "Se volvio anunciar el turno en la pantalla",
            "success"
          );
          console.log(respuesta.data);
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.$swal.fire(
              "Ups!!",
              "Token Invalido Cierre Session e Ingrese de Nuevo",
              "error"
            );
          }
        });
    },
    nopresentacliente() {
      const tokenpeticion = {
        numerodeturno: this.datosdelturno.id,
      };
      axios
        .post("nocepresentocliente", tokenpeticion)
        .then((respuesta) => {
          this.detener()
          this.$swal.fire(
            "Exitoso",
            "Quitado de la cola",
            "success"
          );
          console.log(respuesta.data);
           this.datosdelosturnos();
                this.cantidad_de_turnos();
this.vergestionarturno = false;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.$swal.fire(
              "Ups!!",
              "Token Invalido Cierre Session e Ingrese de Nuevo",
              "error"
            );
          }
        });
    },
    llamarseleccionturno(idturno,numeroturno){
 this.$swal
          .fire({
            title: "Llamar turno",
            text: "Esta seguro de llamar a "+numeroturno+"!",
            icon: "question",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Llamar",
            cancelButtonColor: '#d33',
          })
          .then((result) => {
            if (result.isConfirmed) {
        const tokenpeticion = {
          v_accion:idturno,
        };
        axios
          .post("llamarprioridad", tokenpeticion)
          .then((respuesta) => {
            this.iniciar();
                  this.datosdelosturnos();
                  this.datosdelturno = respuesta.data[0];
                  this.estadoturno = respuesta.data[0].estado_turno;
                  this.cantidad_de_turnos();
                  this.vergestionarturno = true;
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
  }});
}
  },
};
</script>
<style scoped>
.coloriconos {
  color: white;
}
</style>
